import $ from 'jquery';
import rtcViewer from '@/api/webrtc';

let splitScreenMixin = {
	methods: {
    getOfflineThat(webrtcInforms, cameraInfo) {
      return {
        $parent : null,
        $store : null,
        cameraInfo : cameraInfo,
        webrtcInforms: webrtcInforms,
        playPoint : null,
      }
    },
		async getSplitList() { 
			// 분할 화면 리스트 데이터 받아오기
			this.loading = true;
      let params = {};
      await this.networkController.getCameraSplitList(params, this.currentGroupId)
      .then(async (res) => {
        console.log('%cFetch Split Screen List\n', "color:#008DD0;", res.data);
        this.splitScreenList = res.data;
				this.$store.commit('setAllSplitScreenList', res.data);
        if(this.splitScreenList.length === 0){
          this.goCreateSplitScreen();
        } else {
					if(this.$store.state.userData.selectedSplitScreen) {
						this.selectedSplitScreen = this.$store.state.userData.selectedSplitScreen;
					} else {
						this.selectedSplitScreen = this.splitScreenList[0].splitName;
					}
        }
      }).catch(error => { });
    },
		async getSplitListCameras(value) { //선택된 분할화면리스트의 카메라 가져오기 
			this.loading = true;
      // 만들어져있던 player들을 dispose
		  for(let i = 0; i < this.players.length; i++) {
				// 중간에 스트리밍 되지 않은 비디오는 dispose 하면 에러가 나기 때문에 if문으로 처리
        if(this.players[i] != undefined && this.players[i].isDisposed_ != true) 
      	  this.players[i].dispose();
      }

      let params = {};
      let index = this.splitScreenList.findIndex(r => r.splitName == this.selectedSplitScreen); // 분활하면 선택 셀렉트 박스 리스트 중 하나
      if (index === -1) {
        index = 0;
        this.$store.commit('setSelectedSplitScreen', this.splitScreenList[0].splitName);
        this.selectedSplitScreen = this.splitScreenList[0].splitName;
      }
      
			await this.networkController.getCameraSplit(params, this.splitScreenList[index].id)
      .then((res) => {
        this.splitGroupId = res.data.id;
        this.splitScreenCameraList = res.data.cameras;
        for (let i = 0; i < this.splitScreenCameraList.length; ++ i) {
          const item = this.splitScreenCameraList[i];
          this.streamingCount = 0;
          if (item.webrtc) this.getRTCPeerConStream(item, index);
          else this.getAllStreamingUrl(item, index);
        }
        if(value == 0) this.changeViewCount(res.data);
				this.loading = false;
      }).catch(error => {
				this.loading = false;
				console.log(error)
        console.log("get split list cameras error");
			});
    },
		changeViewCount(data) {
			if(data.viewCount) {
				this.viewCount = data.viewCount;
				if(data.viewCount == 4) {
					this.viewCount = 4;
					this.view4 += 1;
				} else if(data.viewCount == 9) {
					this.viewCount = 9;
					this.view9 += 1;
				} else {
					this.viewCount = 16;
					this.view16 += 1;
				}
			} else {
				if(this.splitScreenCameraList.length === 0) {
					this.viewCount = 4;
					this.view4 += 1;
					return;
				}
				let length = this.splitScreenCameraList.length-1;
				if(this.splitScreenCameraList[length].index < 4) {
					this.viewCount = 4;
					this.view4 += 1;
				} else if(this.splitScreenCameraList[length].index > 8) {
					this.viewCount = 16;
					this.view16 += 1;
				} else {
					this.viewCount = 9;
					this.view9 += 1;
				}
			}
    },
    async getRTCPeerConStream(streamData, index) {
      const isSessionFull = await this.checkSessionLimitFull(streamData.contractCd, streamData.portNo);
      if (isSessionFull) {
        this.stopProgressBar(`example-${this.viewCount}-progress${streamData.index}`);
        this.printTextInPlayer(`example-${this.viewCount}-video${streamData.index}`, this.t('errorMsgMaxSession'));
        this.getAllStreamingUrl(streamData, index); 
        return false;
      }
      await this.networkController.setCameraSignalingStart({}, streamData.contractCd, streamData.portNo);
      const res = await this.networkController.getCameraInfo({}, streamData.contractCd, streamData.portNo);
      const info = res.data;
      await this.checkWebRTCReady(streamData.contractCd, streamData.portNo);
      const informs = this.getWebRTCInformations(info);
      const videoEle = document.getElementById(`example-${this.viewCount}-video${streamData.index}`);
      this.createRTCPlayer(videoEle, informs, streamData.index, info);
    },
		async getAllStreamingUrl(streamData, index) {
      let params = {};
      await this.networkController.getHlsStreamingUrl(params, streamData.streamName, '', '')
      .then(async (res) => {
        this.splitScreenCameraList.forEach((item) => {
          if(item.streamName == streamData.streamName && item.index == streamData.index) { //이름과 index가 모두 같은 경우
            this.createPlayer(res.data.hlsstreamingSessionURL, streamData.index);
          }
        });
      }).catch(error => { });
    },
		async getBrandData() {
			let params = {};
			await this.networkController.getBrandList(params).then(async (res) => {
				console.log('%cBrand Data\n', "color:#008DD0;", res.data);
        this.brandList = res.data;
			}).catch(error => { });
			await this.getAreaStores();
		},
		makeBrandCd() {
			if(this.brandList.length == 0) return '';
			return new Promise((resolve) => {
				let brandCd = '';
				this.brandList.forEach((item, index) => {
					if(index == 0) brandCd = item.brandCd;
					else brandCd = brandCd + ',' + item.brandCd;
				});
				resolve(brandCd)
			});
		},
    async getAreaStores() {
			let brandCd = await this.makeBrandCd();
			let params = {};
			await this.networkController.getStoresModalSearch(params, brandCd,'','','','')
			.then(async (res) => {
				console.log('%cArea Data\n', "color:#008DD0;", res.data);
				// Area Data 중복제거
				const arraySet = await res.data.filter((area, idx, arr) => {
					return arr.findIndex((item) => item.unisCustomerCd === area.unisCustomerCd) === idx
				});
        this.storeList = [];
        arraySet.forEach((item) => {
				  let children = [];
          let cameraListparams = {};
			    this.networkController.getStoreCameraList(cameraListparams, item.unisCustomerCd, '', '', '', '', '')
			    .then(async (res) => {
            let childrenList = [];
            res.data.forEach((item) => {
              childrenList.push({"id": item.id, "name": item.cameraName, "lastNode": true, ...item});
            });
            children.push({"id": item.unisCustomerCd, "name": item.customerName, "children": childrenList, ...item});

            let duplicateCheck = this.storeList.some((element) => {
					  	return element.id === item.areaCd
					  });
					  if(duplicateCheck == false) { // duplicateCheck가 true일때는 areaCd 중복
					  	this.storeList.push({"id": item.areaCd, "name": item.areaName, "children": children});
					  }
			    }).catch(error => { });
        });
			}).catch(error => { });
      console.log('%cStore List\n', "color:#008dd0", this.storeList);
    },
		async deleteSplit(id) {
			this.$vloading.show();
      let params = {};
      await this.networkController.deleteCameraSplit(params, id)
      .then(async (res) => {
        console.log("Delete success");
				this.$vloading.hide();
				this.showToastMessage(this.tmb('requestSuccess'));
				await this.$store.commit('setSelectedSplitScreen', null);
        this.getSplitList();
      }).catch(error => {
				this.$vloading.hide();
			})
    },
    async deleteSplitCamera(idx) {
			this.$vloading.show();
      let params = {};
      const index = this.splitScreenCameraList.findIndex(r => r.index === idx);
      this.closeAndDisposeAll();
      await this.networkController.deleteCameraSplitCamera(params, this.splitGroupId, this.splitScreenCameraList[index].contractCd, this.splitScreenCameraList[index].portNo, idx)
      .then((res) => {
				this.showToastMessage(this.tmb('requestSuccess'));
        this.cameraList = res.data.cameras;
        this.$vloading.hide();
        this.getSplitListCameras(0);
      }).catch(error => {
				this.$vloading.hide();
        console.log("delete split camera error");
      });
    },
		goFullScreen() {
			this.$store.commit('setSelectedSplitScreen', this.selectedSplitScreen);
      this.pushRoute('/split-screen/full', { groupId: this.currentGroupId, viewCount: this.viewCount });
    },
		checkSplitScreenCameraList(idx, index_nest, total) {
			return this.splitScreenCameraList[this.splitScreenCameraList.findIndex(
				r => r.index === index_nest + total*idx)] !== undefined
		},
		getSplitName(idx, index_nest, total) {
			return this.splitScreenCameraList[this.splitScreenCameraList.findIndex(r => r.index === index_nest + total*idx)].cameraName;
		},
		showMenu(index, total) {
      if(index == null) {
        for(let i=0; i<total; i++) {
          $("#camera_select_menu" + i).css({'display': 'none'});
				}
      }
      for(let i=0; i<total; i++) {
        if(index != i) { //누른 비디오의 메뉴 제외 모두 display none
          $("#camera_select_menu" + i).css({'display': 'none'});
				} else {//누른 비디오의 메뉴 보여주거나 없애기
          if(document.getElementById("camera_select_menu" + i).style.display == 'none' ||
						document.getElementById("camera_select_menu" + i).style.display == '') {
            document.getElementById("camera_select_menu" + i).style.display = 'block';
					} else {
            document.getElementById("camera_select_menu" + i).style.display = 'none';
					}
				}
      }
    },
		hideMenu() {
      this.showMenu(null, this.viewCount);
    },
		async goVideoPlayer(index) {
			this.$vloading.show();
			const idx = this.splitScreenCameraList.findIndex(r => r.index === index);
			const item = this.splitScreenCameraList[idx];

      //점포그룹에서 라우팅
      this.$store.commit('setPlayerFromWhere', { from: 'splitScreen', name: this.selectedSplitScreen });

      await this.$store.commit('setStreamInfo', item);
      this.$vloading.hide();
      this.pushRoute('/video-player', {
        unisCustomerCd: item.unisCustomerCd,
        customerName: item.cameraName,
        groupId: this.currentGroupId,
      })
    },
    async restartPlayer(index) {
			console.log('restartPlayer', index);
      if (this.players[index]) {
        let streamData = this.splitScreenCameraList[index];
        let params = {};
        await this.networkController.getHlsStreamingUrl(params, streamData.streamName, '', '')
          .then(async (res) => {
            this.stopProgressBar(`example-${this.viewCount}-progress${streamData.index }`);
            this.players[index].src({
              src: res.data.hlsstreamingSessionURL,
              type: 'application/x-mpegURL'
            });
						this.players[index].load();
            this.players[index].play();
          }).catch(error => { })
          .finally(() => {
            this.stopProgressBar(`example-${this.viewCount}-progress${streamData.index}`);
          });
      }
    },
		initializePausePlayInterval() {
      this.pausePlayInterval = setInterval(() => {
        for (let i = 0; i < this.players.length; i++) {
          if (this.players[i] && !this.players[i].paused()) {
            this.players[i].pause();
            this.players[i].play();
          }
        }
      }, 10000);
    },
	}
}
export default splitScreenMixin;